<template>
  <b-card style="border: 1px solid #0000001a">
    <b-col cols="12" class="d-flex justify-content-between align-items-center">
      <h5 class="font-weight-bolder">Security Policies</h5>
      <b-button variant="primary">
        <feather-icon icon="PlusIcon" />
        Add Policy</b-button
      >
    </b-col>

    <b-col cols="12" class="mt-1">
      <b-table
        :items="policies"
        :fields="fields"
        responsive
        thead-class="text-no-wrap"
      >
        <template #cell(name)="data">
          <span class="font-weight-bolder"> {{ data.item.name }}</span>
        </template>
        <template #cell(severity)="data">
          <b-badge :variant="getSeverityVariant(data.item.severity)" pill>
            {{ data.item.severity }}
          </b-badge>
        </template>

        <template #cell(status)="data">
          <b-badge
            :variant="data.item.status === 'Active' ? 'success' : 'secondary'"
            pill
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(actions)>
          <div class="d-flex">
            <b-button size="sm" variant="link">
              <feather-icon icon="EditIcon" class="text-primary" />
            </b-button>
            <b-button size="sm" variant="link">
              <feather-icon icon="TrashIcon" class="text-danger" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
import { BCard, BButton, BTable, BBadge, BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BTable,
    BBadge,
    BRow,
    BCol,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Policy Name" },
        { key: "description", label: "Description" },
        { key: "severity", label: "Severity" },
        { key: "status", label: "Status" },
        { key: "lastUpdated", label: "Last Updated" },
        { key: "actions", label: "Actions" },
      ],
      policies: [
        {
          name: "Password Policy",
          description:
            "Minimum 8 characters with mixed case, numbers and symbols",
          severity: "High",
          status: "Active",
          lastUpdated: "2025-01-05",
        },
        {
          name: "Session Management",
          description: "Automatic session timeout and concurrent login limits",
          severity: "Medium",
          status: "Active",
          lastUpdated: "2025-01-03",
        },
        {
          name: "Data Encryption",
          description:
            "AES-256 encryption for sensitive data at rest and in transit",
          severity: "Critical",
          status: "Active",
          lastUpdated: "2024-12-28",
        },
        {
          name: "Access Control",
          description:
            "Role-based access control with principle of least privilege",
          severity: "High",
          status: "Active",
          lastUpdated: "2025-01-01",
        },
      ],
    };
  },
  methods: {
    getSeverityVariant(level) {
      switch (level) {
        case "Critical":
          return "danger";
        case "High":
          return "warning";
        case "Medium":
          return "info";
        default:
          return "secondary";
      }
    },
  },
};
</script>
